var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-container",style:({
    '--color': _vm.color,
  })},[_c('div',{staticClass:"color-swatch"})])
}
var staticRenderFns = []

export { render, staticRenderFns }